/**
 * 在 Canvas 内部驱动的 FPS 取样器：把 r3f 的 useFrame delta → fps → store。
 * 用于 HUD 与自动画质降级。
 *
 * 性能 :: 平滑值仍然每帧更新（用于 useAutoDegrade hook 的逐帧采样），
 * 但写入 zustand store 是限频的（4 Hz），避免 HUD/订阅者每帧 reconcile。
 */
import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import { useAppStore } from '@/core/store'

const SMOOTHING = 0.05
const STORE_UPDATE_INTERVAL_S = 0.25

export function FpsTracker() {
  const setFps = useAppStore((s) => s.setFps)
  const fpsRef = useRef(60)
  const lastWriteRef = useRef(0)

  useFrame((state, delta) => {
    if (delta <= 0) return
    const sample = 1 / delta
    fpsRef.current = fpsRef.current + (sample - fpsRef.current) * SMOOTHING
    const now = state.clock.elapsedTime
    if (now - lastWriteRef.current >= STORE_UPDATE_INTERVAL_S) {
      lastWriteRef.current = now
      setFps(fpsRef.current)
    }
  })

  return null
}
